import React, { useEffect, useState, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  Grid,
  InputLabel,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Box,
  FormControl,
  MenuItem,
  Select,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  InputAdornment,
  DialogContentText
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import BootstrapInput, { selectOptionStyle } from 'components/commonForm/CommonFormStyle';
import ComplianceUpload from 'pages/compliance/ComplianceUpload';
import CommonCropImage from 'components/commonCropImage/CommonCropImage';
import { dateFormate, handleValidationForm } from 'utils/utils';
import Loader from 'components/loader/Loader';
import { minDate } from 'utils/enumObject';
import camera from 'assets/images/camera.svg';
import profile from 'assets/images/SubVendorLogo.svg';
import lockicon from 'assets/images/lockicon.svg';

export default function CommonMultiImageForm(props) {
  const regNumberRef = useRef(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const {
    register,
    handleSubmit,
    setValue,
    reset: resetForm,
    formState: { errors },
    trigger,
    control,
    clearErrors,
  } = useForm({ defaultValues: props?.defaultValues, mode: 'onChange' });
  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(
    props?.selectType === 'edit' ? false : true
  );
  const formData = props?.formData ? props?.formData : [];
  // ---Country Code---
  const [country, setCountry] = useState('+91');
  const [image, setImage] = useState(null);
  const [imgError, setImgError] = useState('');
  const [imgPlaceholder, setImgPlaceholder] = useState(true);
  const [seater, setSeater] = useState('');
  const [selectValues, setSelectValues] = useState({});
  const maxDate = dateFormate(new Date(),'YYYY-MM-DD');
  const loaderVehicle = useSelector((state) => state?.userAddVehicle?.loading);
  const complianceLoader = useSelector(
    (state) => state?.userOnBoardCompliance?.loading
  );
  const complianceUpdateLoader = useSelector(
    (state) => state?.userAddOnBoardCompliance?.loading
  );
  const [imageObj, setImageObj] = useState({});
  const handleInput = (e,capital) => {
    if (e.target.name === 'carTypeId') {
      clearErrors('seating');
      setValue('seating', e.target.value, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
    const { name, value } = e.target;
      // If capitalize is true, convert the value to uppercase
      const processedValue = capital ? value.toUpperCase() : value;
      setValue(name, processedValue);

    if (e.target.name) {
      clearErrors(e.target.name);
    }

    let data = {};
    data[e.target.name] = e.target.value;
    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);
    if (validationData.formIsValid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  useEffect(() => {
    if (props.defaultValues) {
      setSelectValues(props.defaultValues);
    }
  }, [props.defaultValues]);

  const chunkSize = 10; // Number of elements to show in each step
  const formDataChunks = [];
  for (let i = 0; i < formData.length; i += chunkSize) {
    formDataChunks.push(formData?.slice(i, i + chunkSize));
  }

  const [currentStep, setCurrentStep] = useState(0);
  const currentFormData = formDataChunks[currentStep];

  const handleNext = async () => {
    const validation = await trigger();
    if (props?.defaultValues?.avtar?.url || (image && image !== null)) {
      if (validation) {
        if (currentStep < formDataChunks.length - 1) {
          setCurrentStep(currentStep + 1);
        }
      }
    } else {
      const errorScroll = document.getElementsByClassName('errorMessage');
      const imageScroll = document.getElementsByClassName('uploadBtn');
      if(imageScroll){
        setImgPlaceholder(false)
        imageScroll[0].parentElement.scrollIntoView({block: 'start',})
      }
      else if (errorScroll.length > 0) {
        errorScroll[0].parentElement.scrollIntoView({
          block: 'start',
        })
      } 
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  // ---Form Validation---

  const onSubmit = (data) => {
    seater !== ''
      ? props.onSubmittBtn({ ...data, seating: seater }, country, formData)
      : props.onSubmittBtn(data, country, formData);
    setSeater('');
    resetForm();
  };

  const handelSeat = (e) => {
    currentFormData &&
      currentFormData.map((el) => {
        if (el.options) {
          el.options.filter((item) => {
            if (item.value === e.target.value) {
              setSeater(item.seater);
            }
          });
        }
      });
  };
  const [fileTypeError, setFileTypeError] = useState('');
  const onImageChange = (event) => {
    setFileTypeError('');
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImageObj(event.target.files[0])
      const attributeType = ['image/jpeg', 'image/png'];
      const allowedExtensions = ['jpeg', 'jpg', 'png'];

      const fileExtension = img.name.split('.').pop().toLowerCase();

      if (!attributeType.includes(img.type) || !allowedExtensions.includes(fileExtension)) {
        const typeError = 'File type should be in png/jpg/jpeg';
        setFileTypeError(typeError);
        setImgPlaceholder(true);
      } else if (event.target.files[0].size > 1024000) {
        const errorVal = 'Image size should not be more than 1 MB';
        setImgError(errorVal);
        setImgPlaceholder(true);
      } else {
        setFileTypeError('');
        setSrc(URL.createObjectURL(img));
        setModalOpen(true);
        if (img) {
          setImgPlaceholder(true);
        }
      }
      event.target.value = '';
    }
  };

  const handleErrorImg = (event) => {
    const typeError = 'Please choose proper image'
    setFileTypeError(typeError)
    setModalOpen(false)
  }

  const handleClose = () => {
    props.handleClose();
    resetForm();
    setImage(null);
    setSelectValues({});
    setCurrentStep(0);
    setFileTypeError('');
    setImgPlaceholder(true);
    setImgError('');
    setSrc('')
  };

  const handelNegativeInput = (event) => {
    // Check if the input value is valid
    if (!event.target.validity.valid) {
      // If not valid, clear the input value
      setValue(event?.target.name, '');
    }
  };

  const dummyFunctiom = (e) => {
    return;
  };

  const [src, setSrc] = useState(null);
  // modal state
  const [modalOpen, setModalOpen] = useState(false);



  const handleCropSave = (blob) => {
   setImage(URL.createObjectURL(blob));
   const file = new File([blob], imageObj?.name, {lastModified: new Date()})
   props?.onImageChange(file);
 }
 const title = (type) =>{
  return type
    .trim()
    .split(' ')
    .map((word, index, array) => {
const isLastWord = index === array.length - 1;
return (
  <span
      key={index}
      className={
          isLastWord ? 'colorSecondary'
           : 'colorPrimary'
      }>
      &nbsp;{word}
  </span>
);
})}

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className='modelMain'>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className='modelCloseIcon'
          >
            <CloseIcon />
          </IconButton>
          <Grid container>
            <Grid item xs={12} className="dialogHead justifyCenter">
              {props.selectType === 'Send' ? (
                <Typography>
                  {props.selectType === 'Send' ? props.type : ''}
                </Typography>
              ) : props.selectType === 'edit' ? (
                <Typography className="titleStyle">
                 {title(props?.type)}
                </Typography>
              ) : props.selectType === 'Create' ? (
                <Typography className="titleStyle">
                  {props?.showOtherComponent ? 'Upload Vehicle' : 'Add '}
                  <span className="colorSecondary">{props?.showOtherComponent ? ' Compliance' : props.type}</span>
                </Typography>
              ) : props.selectType === 'vendorAdd' ? (
                <Typography className="titleStyle">
                  {'Enter '} {props.type}
                  <span className="colorSecondary">{' Details'}</span>
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props?.showOtherComponent ? (
              <>
                {complianceLoader || complianceUpdateLoader ? (
                  <div>
                    <Loader />
                  </div>
                ) : (
                  <ComplianceUpload
                    reupload={props?.reupload}
                    tabName={props?.tabName}
                    vehicleId={props?.vehicleId}
                    driverId={props?.driverId}
                    details={props?.details}
                    onSuccess={props?.onSuccess}
                  />)}</>
            ) : ( <Grid container>
              {loaderVehicle ? (
                <div className="width100 justifyCenter">
                  <Loader height={'50vh'} />
                </div>
              ):(           
              <Grid container>
                <Grid item xs={12} className="formPadding">
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {currentFormData?.map((ele, idx) => (
                        <div key={ele.name}>
                          {ele.type === 'file' ? (
                            <>
                              <Button
                                variant="contained"
                                component="label"
                                className="uploadBtn"
                              >
                                <CommonCropImage
                                  modalOpen={modalOpen}
                                  src={src}
                                  setModalOpen={setModalOpen}
                                  handleCropSave={handleCropSave}
                                />
                                <img
                                  src={
                                    image && image != null
                                      ? image
                                      : props?.defaultValues?.avtar?.url
                                      ? props?.defaultValues?.avtar?.url
                                      : profile
                                  }
                                  alt="profile"
                                  className="imgFormSize"
                                />
                                {src && <img
                                  src={src}
                                  alt="profile"
                                  className="imgFormSize"
                                  style={{display:'none'}}
                                  onError={handleErrorImg}
                                />}
                                <div className="imgOuter">
                                  <img src={camera} alt="camera" 
                                   />
                                </div>
                                <input
                                  type="file"
                                  {...register(ele?.name, {
                                    onChange: (e) => onImageChange(e),
                                  })}
                                  hidden
                                  disabled={props?.selectType === 'edit' && true}
                                  accept="image/*"
                                />
                              </Button>
                              {((props?.defaultValues?.avtar?.url) || (imgPlaceholder)) ? "" : (
                                <div
                                  className='errorMessage'
                                >
                                  Image is required
                                </div>
                              )}
                              {imgError && imgError !== null && (
                                <div className="errorMessage">{imgError}</div>
                              )}
                              {fileTypeError && fileTypeError !== null && (
                                <div className="errorMessage">
                                  {fileTypeError}{' '}
                                </div>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: 'grid',
                              }}
                              className={`${
                                idx === currentFormData?.length - 1
                                ? '0'
                                : 'mb25'
                              }`}
                            >
                              <FormControl variant="standard">
                                <p className="commonformLabel">
                                  {ele?.label}
                                  {ele?.required && (
                                    <span className="colorRed">
                                      {ele?.star || '*'}
                                    </span>
                                  )}
                                </p>
                                <Box className='dflex'>
                                  <FormControl
                                    fullWidth
                                    className="commonFormControl"
                                  >
                                    {ele?.options ? (
                                      <Select
                                        displayEmpty
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                        })}
                                        MenuProps={{
                                          PaperProps: {
                                            style:selectOptionStyle
                                          },
                                        }}
                                        onChange={(e) => {
                                          if (props.defaultValues) {
                                            // Update the state variable with user-selected value
                                            setSelectValues((prevValues) => ({
                                              ...prevValues,
                                              [ele?.name]: e.target.value,
                                            }));
                                          } else {
                                            // If no default values, directly update the state
                                            setSelectValues((prevValues) => ({
                                              ...prevValues,
                                              [ele?.name]: e.target.value,
                                            }));
                                          }
                                          handleInput(e);
                                          if (ele?.name === 'carTypeId') {
                                            handelSeat(e);
                                          }
                                        }}
                                      >
                                        <InputLabel
                                          disabled
                                          className="colorGrey marginLeft16"
                                        >
                                          {props?.selectType === 'edit' && selectValues[ele?.name]
                                            ? selectValues[
                                                ele?.name === 'carTypeId'
                                                  ? 'carType'
                                                  : ele?.name
                                              ]
                                            : ele.placeholder}
                                        </InputLabel>
                                        {ele?.options.map((option) => (
                                          <MenuItem
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    ) : ele?.values ? (
                                      <>
                                        <FormControl>
                                          <Controller
                                            name={ele?.name}
                                            control={control}
                                            rules={{ required: ele?.required }}
                                            render={({ field }) => {
                                              return (
                                                <RadioGroup
                                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                                  {...field}
                                                >
                                                  {ele?.values.map((value) => (
                                                    <FormControlLabel
                                                      key={value.label}
                                                      value={value.value}
                                                      control={<Radio />}
                                                      label={value.label}
                                                    />
                                                  ))}
                                                </RadioGroup>
                                              );
                                            }}
                                          />
                                        </FormControl>
                                      </>
                                    ) : ele?.name === 'seating' ? (
                                      <BootstrapInput
                                        placeholder={ele?.placeholder}
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                        })}
                                        type={ele?.type}
                                        id="bootstrap-input"
                                        error={
                                          !!(
                                            errors[ele?.name] ||
                                            formError[ele?.name]
                                          )
                                        }
                                        onChange={(e) => {
                                          handleInput(e);
                                        }}
                                        disabled={
                                          ele?.editProps &&
                                          props?.editIconId === ele?.id
                                            ? false
                                            : ele?.disabled ||
                                              ele?.placeholder === 'seating'
                                            ? true
                                            : false
                                        }
                                        multiline={ele?.multiline || false}
                                        rows={ele?.row || ''}
                                        defaultValue={
                                          seater !== '' ? seater : ele.value
                                        }
                                        value={
                                          seater !== '' ? seater : ele?.value
                                        }
                                        endAdornment={
                                          <InputAdornment
                                            position="start"
                                          >
                                            {ele?.editProps &&
                                              props?.editIconId !== ele?.id && (
                                                <IconButton className="editIconCommon"></IconButton>
                                              )}
                                            {ele?.disabled &&
                                              ele?.disabled === true &&
                                              !ele?.editProps && (
                                                <IconButton className="editIconCommon cursorAuto">
                                                  <img
                                                    src={lockicon}
                                                    alt="lockicon"
                                                  />
                                                </IconButton>
                                              )}
                                          </InputAdornment>
                                        }
                                      />
                                    ) : ele?.name === 'regNumber' ? (
                                      <TextField
                                        placeholder={ele?.placeholder}
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                          validate: (value) => {
                                            // Regular expression to allow only numbers and alphabets
                                            const alphanumericRegex = /^[a-zA-Z0-9]*$/; 
                                            
                                            // First check if the field is empty (required validation)
                                            if (!value || value.trim().length === 0) {
                                              setFormError((prev) => ({
                                                ...prev,
                                                regNumber: 'This field is required',
                                              }));
                                              regNumberRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Scroll to the input
                                              return 'This field is required'; // Return error message for required field
                                            }
                                            
                                            // Check if the value matches the alphanumeric regex
                                            if (!alphanumericRegex.test(value)) {
                                              setFormError((prev) => ({
                                                ...prev,
                                                regNumber: 'Enter a valid Vehicle Number',
                                              }));
                                              regNumberRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Scroll to the input
                                              return 'Enter a valid Vehicle Number'; // Validation fails
                                            }
                                            
                                            // Clear errors if validation is successful
                                            setFormError((prev) => {
                                              const newErrors = { ...prev };
                                              delete newErrors[ele?.name]; // Remove any error for regNumber
                                              return newErrors;
                                            });
                                            
                                            return true; // Validation successful
                                          },
                                        })}
                                        type={ele?.type}
                                        id="bootstrap-input"
                                        error={
                                          !!(
                                            errors[ele?.name] ||
                                            formError[ele?.name]
                                          )
                                        }
                                        onChange={(e) => {
                                          handleInput(e,ele?.capital);
                                        }}
                                        disabled={
                                          ele?.editProps &&
                                          props?.editIconId === ele?.id
                                            ? false
                                            : ele?.disabled ||
                                              ele?.placeholder === 'seating'
                                            ? true
                                            : false
                                        }
                                        defaultValue={ele?.defaultValue}
                                        inputRef={regNumberRef}
                                        InputProps={{
                                          inputProps: {
                                            min:
                                              ele?.type === 'date'
                                                ? minDate
                                                : ele?.type === 'number'
                                                ? 0
                                                : '',
                                            max:
                                              ele?.type === 'date'
                                                ? maxDate
                                                : '',
                                          },
                                          onInput:
                                            ele?.type === 'number'
                                              ? handelNegativeInput
                                              : dummyFunctiom,
                                        }}
                                        endAdornment={
                                          <InputAdornment position="start">
                                            {ele?.editProps &&
                                              props?.editIconId !==
                                                ele?.id && (
                                                <IconButton className="editIconCommon"></IconButton>
                                              )}
                                            {ele?.disabled &&
                                              ele?.disabled === true &&
                                              !ele?.editProps && (
                                                <IconButton className="editIconCommon cursor_auto">
                                                  <img
                                                    src={lockicon}
                                                    alt="lockicon"
                                                  />
                                                </IconButton>
                                              )}
                                          </InputAdornment>
                                        }
                                      />
                                    ): (
                                      <TextField
                                        placeholder={ele?.placeholder}
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                        })}
                                        type={ele?.type}
                                        id="bootstrap-input"
                                        error={
                                          !!(
                                            errors[ele?.name] ||
                                            formError[ele?.name]
                                          )
                                        }
                                        onChange={(e) => {
                                          handleInput(e,ele?.capital);
                                        }}
                                        disabled={
                                          ele?.editProps &&
                                          props?.editIconId === ele?.id
                                            ? false
                                            : ele?.disabled ||
                                              ele?.placeholder === 'seating'
                                            ? true
                                            : false
                                        }
                                        multiline={ele?.multiline || false}
                                        rows={ele?.row || ''}
                                        defaultValue={ele?.defaultValue}
                                        InputProps={{
                                          inputProps: {
                                            min:
                                              ele?.type === 'date'
                                                ? minDate
                                                : ele?.type === 'number'
                                                ? 0
                                                : '',
                                            max:
                                              ele?.type === 'date'
                                                ? maxDate
                                                : '',
                                          },
                                          onInput:
                                            ele?.type === 'number'
                                              ? handelNegativeInput
                                              : dummyFunctiom,
                                        }}
                                        endAdornment={
                                          <InputAdornment
                                            position="start"
                                          >
                                            {ele?.editProps &&
                                              props?.editIconId !== ele?.id && (
                                                <IconButton className="editIconCommon"></IconButton>
                                              )}
                                            {ele?.disabled &&
                                              ele?.disabled === true &&
                                              !ele?.editProps && (
                                                <IconButton className="editIconCommon cursorAuto">
                                                  <img
                                                    src={lockicon}
                                                    alt="lockicon"
                                                  />
                                                </IconButton>
                                              )}
                                          </InputAdornment>
                                        }
                                      />
                                    )}
                                  </FormControl>
                                </Box>
                                {/* errors will return when field validation fails  */}

                                {errors[ele?.name] && !formError[ele?.name] && (
                                  <div className="errorMessage">
                                    This field is required
                                  </div>
                                )}
                                {formError[ele?.name] && (
                                  <div className="errorMessage">
                                    {formError[ele?.name]}
                                  </div>
                                )}
                              </FormControl>
                            </Box>
                          )}
                        </div>
                      ))}

                      {props?.button && props?.button === 'dialogButton' && (
                        <Box>
                          <Grid container className="btnDialogContainer">
                            {currentStep > 0 && (
                              <Grid item xs={5}>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className="cancelAddBtn"
                                  fullWidth
                                  onClick={handlePrevious}
                                >
                                  Back
                                </Button>
                              </Grid>
                            )}
                            {currentStep < formDataChunks.length - 1 && (
                              <Grid
                                item
                                container
                                direction="row"
                                justifyContent="center"
                              >
                                <Grid item sm={6}>
                                  <Button
                                    variant="contained"
                                    size="medium"
                                    className="buttonSubmit"
                                    fullWidth
                                    onClick={handleNext}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                            {currentStep === formDataChunks.length - 1 && (
                              <Grid item xs={5}>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className={`buttonSubmit  ${
                                    isDisabled ? 'buttonSubmitDisabled' : ''
                                  }`}
                                  type="submit"
                                  fullWidth
                                  disabled={isDisabled}
                                >
                                  {props?.selectType === 'edit'
                                    ? 'Update'
                                    : props?.selectType === 'Send'
                                    ? 'Send'
                                    : 'Create'}
                                </Button>
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      )}
                    </form>
                  </div>
                </Grid>
              </Grid>)}
              </Grid>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
